var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "facebook-logo",
    transform: "translate(-0.01)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_01.facebook",
    "data-name": "01.facebook"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "background",
    cx: 48.5,
    cy: 48.5,
    r: 48.5,
    transform: "translate(0.01)",
    fill: "#3a559f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M90.785,57.524l-.974,8.433a1.579,1.579,0,0,1-1.551,1.414h-8.8l-.044,25a1.128,1.128,0,0,1-1.1,1.139H69.4a1.1,1.1,0,0,1-1.1-1.144v-25H61.7a1.579,1.579,0,0,1-1.562-1.6L60.1,57.342a1.584,1.584,0,0,1,1.562-1.606H68.3V47.594C68.3,38.144,73.908,33,82.137,33h6.744a1.584,1.584,0,0,1,1.568,1.606v7.1a1.584,1.584,0,0,1-1.568,1.606H84.745c-4.472,0-5.342,2.2-5.342,5.38v7.047h9.83a1.584,1.584,0,0,1,1.551,1.788Z",
    transform: "translate(-27.039 -14.847)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLogo);
export default __webpack_public_path__ + "static/media/facebook-logo.73333a34ea978b37b65684626548bc70.svg";
export { ForwardRef as ReactComponent };